import { useContext, useEffect } from 'react'
import { Colorcontext } from '../../Component/Colorcontext/ColorContext';
import SeoGeneral from '../BusinessPage/SeoGeneral';

function PrivacyPolicy() {
    const colordata = useContext(Colorcontext);
    useEffect(() => {
        colordata.setcolor(true);
        return () => {
            colordata.setcolor(false);
        };
    }, []);

    const seoMetaData = {
        title: "Neoo Search Privacy Policy – Data Protection & Lead Generation",
        description: "Read Neoo Search Privacy Policy to understand how we collect, use, and protect your personal data while using our business directory and digital business card platform.",
        ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
        ogImageAlt: "Neoo Search Privacy Policy – Data Protection & Lead Generation",
        url: process.env.REACT_APP_APPLICATION_URL + "/privacy-policy",
        keywords: "Neoo Search, privacy policy, data protection, lead generation, business directory, digital business card",
        type: "website",
        site_name: "NeooSearch",
        canonical: process.env.REACT_APP_APPLICATION_URL + "/privacy-policy"
    };

    return (
        <>
            <SeoGeneral data={seoMetaData} />
            <section className='aboutneoosearch_sec searchloginmain'>
                <div className='cust_container'>
                    <div className='toparea'>
                        <h4 className='headline'>Neoo Search Privacy Policy</h4>
                        <p className='text'>At <strong>Neoo Search</strong>, we respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our platform.</p>
                    </div>

                    <div className='textarea'>
                        <h4 className='headline'>Lead Generation Policy</h4>
                        <p className='text'>This Lead Generation Policy explains how Neoo Search manages and processes business leads generated through NeooCard, business listings, and networking features on our platform. By using our services, you agree to this policy.</p>

                        <h4 className='headline'>1. Purpose of Lead Generation</h4>
                        <ul>
                            <li className='text ml-5'>To connect businesses and professionals with potential clients, partners, and service providers.</li>
                            <li className='text ml-5'>To create opportunities for networking, collaboration, and business growth.</li>
                            <li className='text ml-5'>To ensure that inquiries and leads are directed to the right business listings and card owners.</li>
                        </ul>

                        <h4 className='headline'>2. Information We Collect</h4>
                        <ul>
                            <li className='text ml-5'><strong>Account Information:</strong> Name, email, phone number, company details.</li>
                            <li className='text ml-5'><strong>NeooCard Data:</strong> Contact details, business information, logos, and images you provide.</li>
                            <li className='text ml-5'><strong>Payment Information:</strong> For premium services (processed securely by third-party providers).</li>
                            <li className='text ml-5'><strong>Usage Data:</strong> Browser type, device info, IP address, and interaction with the platform.</li>
                        </ul>

                        <h4 className='headline'>3. How We Use Your Information</h4>
                        <ul>
                            <li className='text ml-5'>To provide free and paid services (NeooCard, business listings).</li>
                            <li className='text ml-5'>To process payments and manage subscriptions.</li>
                            <li className='text ml-5'>To improve platform functionality and user experience.</li>
                            <li className='text ml-5'>To send updates, promotional offers, and service-related communications.</li>
                            <li className='text ml-5'>To comply with legal obligations.</li>
                        </ul>

                        <h4 className='headline'>4. Data Sharing & Disclosure</h4>
                        <ul>
                            <li className='text ml-5'>We do <strong>not sell or rent</strong> your personal data..</li>
                            <li className='text ml-5'>Information may be shared with:</li>
                            <ul className='ml-5'>
                                <li className='text ml-5'><strong>Payment processors</strong> (for secure transactions).</li>
                                <li className='text ml-5'><strong>Service providers</strong> (hosting, analytics, customer support).</li>
                                <li className='text ml-5'><strong>Legal authorities</strong>Legal authorities if required by law.</li>
                            </ul>
                        </ul>

                        <h4 className='headline'>5. Data Storage & Security</h4>
                        <ul>
                            <li className='text ml-5'>Access is restricted to authorize personnel only.</li>
                            <li className='text ml-5'>Despite safeguards, no method of transmission or storage is 100% secure — users share data at their own risk.</li>
                        </ul>

                        <h4 className='headline'>6. User Rights</h4>
                        <p className='text'>Depending on your location, you may have the right to:</p>
                        <ul>
                            <li className='text ml-5'>Access, correct, or update your personal and business information.</li>
                            <li className='text ml-5'>Request deletion of your data.</li>
                            <li className='text ml-5'>Marketing communications.</li>
                            <li className='text ml-5'>Withdraw consent at any time.</li>
                        </ul>

                        <h4 className='headline'>7. Cookies & Tracking</h4>
                        <ul>
                            <li className='text ml-5'>We use cookies to improve performance and user experience.</li>
                            <li className='text ml-5'>Cookies help with login sessions, preferences, and analytics.</li>
                            <li className='text ml-5'>Users can disable cookies in their browser, but some features may not work properly.</li>
                        </ul>

                        <h4 className='headline'>8. International Users (GCC & India)</h4>
                        <ul>
                            <li className='text ml-5'>By using Neoo Search in the <strong>GCC</strong> and <strong>India</strong>, you consent to your data being processed and stored in accordance with this Privacy Policy and applicable local laws.</li>
                        </ul>

                        <h4 className='headline'>9. Updates to Policy</h4>
                        <ul>
                            <li className='text ml-5'>We may update this Privacy Policy from time to time.</li>
                            <li className='text ml-5'>Users will be notified of significant changes via email or platform notifications.</li>
                        </ul>

                        <h4 className='headline'>10. Contact Us</h4>
                        <p className='text'>If you have any questions about this Privacy Policy, please contact us at:</p>
                        <p className='text'>support@neoosearch.com</p>
                    </div>

                </div>
            </section>
        </>
    )
}

export default PrivacyPolicy